<!--历史值-->
<template>

  <div class="myhistoryValue">
    <div class="con">
      <div class="tree-left">
        <elUnitTree @checkFun='checkFun' :dataList='virtualDeviceList'></elUnitTree>
      </div>
      <div class="right-table">
        <div class="Files-top">
          <div class="ic-left">
            <span>历史列表</span>
          </div>
          <div class="btns">
            <el-button @click="exportButton" type="primary" class="last-el-button">导出</el-button>
          </div>
        </div>
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <span>应用类型组：</span>
                <!-- <el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择">
                  <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
                  <el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select> -->
                <el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择">
                            <el-option label='全选' value='全选' @click.native='selectAll'></el-option>
                            <el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                          </el-select>
              </div>
              <div class="input-small mr-20">
                <span>日期：</span>
                <el-date-picker value-format="timestamp" v-model="datetimeValue" type="daterange"
                  :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期"></el-date-picker>
              </div>
              <div class="input-small myinput">
                <span>间隔(分钟)：</span>
                <el-select v-model="timeInterval" placeholder="请选择" @change="timeInterval_fn">
                  <el-option v-for="item in times" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
              <el-button type="primary" plain @click="searchHistory" class="search-btn">查询</el-button>
            </div>
          </el-scrollbar>

        </div>
        <div class="mytable"  id="region-cost">
          <el-table :data="dataList" v-loading="loading" :height="heights" border style="width: 100%;">
            <el-table-column label="序号" width="90" align="center">
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="variablename" label="变量名" width="260"> </el-table-column>
            <el-table-column prop="dateTimer" label="日期" width="180"> </el-table-column>
            <el-table-column prop="max" label="最大值" width="90"> </el-table-column>
            <el-table-column prop="min" label="最小值" width="90"> </el-table-column>
            <el-table-column v-for="(e,i) in coloms" :key="i" :prop="e" :label="e" :width=" e==  'variablename'? 260:90"
              align="center">
            </el-table-column>
          </el-table>
        </div>



      </div>
      <downloadTable ref="downloadTable"></downloadTable>
    </div>
  </div>
</template>

<script type="text/javascript">
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import downloadTable from '@/components/module/downloadTable/downloadTable.vue'
  import request from "@/api/http.js";
  export default {
    components: {
      elUnitTree,
      downloadTable
    },
    props: [],
    data () {
      return {
        heights: document.getElementById('app').clientHeight-250,
        dataList: [],
        coloms: [],
        list2: [],
        flag: true,
        nowVirtualDevice: undefined,
        apptypeValue: [],
        nowApptypeGroups: [],
        checkVariablename: [], //需要显示的变量名称
        timeToValue: {}, //变量名+年+月+日:288个数据
        timeInterval: 30, //时间间隔,单位是分钟
        totalSize: 0,
        pageLen: 48,
        nowIndex: 0,
        from2name: {},
        datetimeValue: [new Date(new Date().toLocaleDateString()).getTime(),new Date().getTime()],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*7);
              picker.$emit('pick',[start,end]);
            }
          },{
            text: '最近一个月',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*30);
              picker.$emit('pick',[start,end]);
            }
          }]
        },
        times: [5,15,30,60],
        arr15: [],
        arr30: [],
        arr60: [],
        colomsCopy: [],
        nowDevice: [],
        nowVirtualDeviceList:[],
         loading: false,//页面加载
      }
    },
    

    mounted () {
        setTimeout(() => {
        this.apptypeValue=['全选'];
        this.selectAll();
      },1000)
        //  this.apptypeValue=this.nowSelectAppTypeGroupIds
    },
    computed: {

      // nowDevice () {
      //   let device=this.$store.deviceStore.state.nowVirtualDevice
      //   let list={name: ''}
      //   if(!isempty(device)) {
      //     list=device
      //   }
      //   return list
      // },
      variableStore () {
        return this.$store.variableStore
      },
      deviceStore () {
        return this.$store.deviceStore
      },
        variableTree () {
        if(isempty(this.nowVirtualDeviceList)) {
          return []
        }
        var variableTreeArr=[]
        this.nowVirtualDeviceList.forEach(item => {
          var variableTree=[]
          if(item.type=="virtualDevice") {
            if(variableTree.length==0) {
              variableTree=this.variableStore.getters.getVariableTree(item.no)
            }
          }
          variableTree.forEach(tree => {
            tree.devicename=item.name
          })
          variableTreeArr.push(variableTree)
        })
        var result=[]
        variableTreeArr.forEach(item => {
          result=result.concat(item)
        })
        return result
      },
      apptypeGroups () {
        //所有已选中的设备所具有的变量类型组
        var list=[]
        var apptypeGroupIds=[]
        // console.log("this.variableTree",this.variableTree);
        this.variableTree.forEach(apptypeGroup => {
          if(!apptypeGroupIds.includes(apptypeGroup.id)) {
            apptypeGroupIds.push(apptypeGroup.id)
            list.push(apptypeGroup)
          }
        })
        //排序
        list.sort((a,b) => {
          return a.serialnum-b.serialnum
        })
        
         let idList=[]
          list.forEach(item => {
            idList.push(item.id)
          })
          this.apptypeValue=idList
        return list
      },
      apptypes () {
        //当前选中的这些变量类型组下面的变量类型列表
        var list=[]
        this.apptypeGroups.forEach(item => {
          list=list.concat(this.variableStore.getters.getApptypeByGroupId(item.id))
        })
        return list
      },

      nowVariableNames () {
        //当前应该显示的变量fromname列表
        var ag=this.nowApptypeGroups.map(item => {
          return item.id
        })
        var v1=this.variableTree.filter(item => {
          return ag.includes(item.id)
        })
        if(isempty(v1)) {
          return []
        }
        var v2=[]
        v1.forEach(item => {
          item.next.forEach(i => {
            this.from2name[i.fromName]=i.name+'('+item.unit+')'
            v2.push(i.fromName) //name != fromName
          })
        })
        return v2
      },
      virtualDeviceList () {
        var data=this.$store.deviceStore.getters.getReadDeviceTree
        return isempty(data)? []:[deviceList(data)]
      },
      nowSelectAppTypeGroupIds () {
        return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
      },
      

    },
    watch: {
      nowDevice (nv,ov) {
        this.timeToValue={}
        // this.searchHistory()
      },
      apptypeValue (nv,ov) {
          var num  = nv.findIndex(item => item == '全选')
          if(nv.length != 0 && num == -1){
            this.searchHistory()
          }else {
             this.dataList  = []
          }
        
      },
      datetimeValue () {
        // this.searchHistory()
      },

    },
    methods: {
      
      checkFun (val) {
        var d=[]
        this.list2=[]
        this.nowVirtualDevice=val;
        this.nowDevice=val[0]
        this.nowVirtualDeviceList = val
      },
     selectAll () {
        //全选 先判断是否有选中的，有选中就清空
        if(this.apptypeValue.length == 1) {
          this.nowApptypeGroups = this.apptypeGroups
          let idList=[]
          this.nowApptypeGroups.forEach(item => {
            idList.push(item.id)
          })
          this.apptypeValue=idList
          // this.searchHistory()
        } else {
          this.nowApptypeGroups=[]
          this.apptypeValue=[]
          
        }
      },
      autoSelectMethod (item,index) {
        if(this.nowDevice!=undefined) {
          return this.nowDevice.id==item.id&&this.nowDevice.type==item.type
        } else {
          return item.type=='virtualDevice'
        }
      },
      searchHistory () {
        if(this.datetimeValue[1]-this.datetimeValue[0]>=180*24*60*60*1000) {
          this.$message({
            message: '时间跨度请勿超过180天',
            type: 'warning'
          })
          return
        }
        if(this.apptypeValue.length == 0) {
          this.$message({
            message: '请选择应用类型组',
            type: 'warning'
          })
          return
        }
        var d=[]
        this.nowVirtualDevice.map(v => {
          d.push(v.no)
        })

        // this.$dialogMethod.showLoading('历史值正在加载...');

        var params={
          bgTime: this.datetimeValue[0],
          deviceNos: d.join(','),
          endTime: this.datetimeValue[1],
          typeGroupIds: this.apptypeValue.join(','),
        }
        this.loading =  true
        request({url: "/histories/getDeviceHistory",method: "get",params}).then(res => {
            this.loading = false
          if(res.code==200) {
            this.listFilter(res.data)
          }
        })

       
      },
      // 过滤数据
      listFilter (v) {
        var d=[];//数据
        var coloms=[];//键
        var str=""
        v.map(a => {
          a.energyHistory.map((b,i) => {
            b.issueValues.map(c => {
              // deviceName: a.deviceName,
              //   deviceType: b.deviceType,
              var colomData={}
              for(const key in c) {
                if(key.includes("value")) {
                  str=key.substring(5,7)+' : '+key.substring(7,9)
                  colomData[str]=c[key]==-1.1111? "":c[key];
                } else {
                  colomData[key]=c[key]==-1.1111? "":c[key];
                }
                if(!d.length) {
                  if(key.includes("value")) {
                    str=key.substring(5,7)+' : '+key.substring(7,9)
                    coloms.push(str)
                  }
                }
                // console.log("内部循环",colomData,b.selectTime);
              }
              colomData.dateTimer = b.selectTime
              d.push(colomData)
  

            })
            // d[i].dateTimer=b.selectTime
          })

        })

        this.colomsCopy=JSON.parse(JSON.stringify(coloms))
        this.colomsFn()
        this.dataList=d;

      },
      // 过滤键方法
      colomsFn () {
        var str=""
        this.arr15=[]
        this.arr30=[]
        this.arr60=[]
        if(this.timeInterval==5) {
          this.coloms=JSON.parse(JSON.stringify(this.colomsCopy));
        } {
          this.colomsCopy.forEach(item => {
            str=item.substring(5,7)
            if(str=="00"||str=="15"||str=="30"||str=="45") {
              this.arr15.push(item)
            }
            if(str=="00"||str=="30") {
              this.arr30.push(item)
            }
            if(str=="00") {
              this.arr60.push(item)
            }
          })
        }
        this.timeInterval_fn(this.timeInterval)


      },
      timeInterval_fn (val) {
        this.flag=false
        if(val==5) {
          this.coloms=JSON.parse(JSON.stringify(this.colomsCopy));
        } else if(val==15) {
          this.coloms=this.arr15
        } else if(val==30) {
          this.coloms=this.arr30
        } else if(val==60) {
          this.coloms=this.arr60
        }
        setTimeout(() => {
          this.flag=true
        },500)
      },
      exportButton () {

        let time=new Date();
        let year=time.getFullYear();
        let month=time.getMonth()+1;
        let day=time.getDate();
        console.log("datetimeValue",this.datetimeValue);
        // this.date_format_fn(this.dateValue)
        const tHeader=['查询时间',this.date_format_fn(this.datetimeValue[0])+'-'+this.date_format_fn(this.datetimeValue[1]),'间隔(分钟)',this.timeInterval];
        //  this.export2Excel(tHeader,this.tableData,year + "-" + month + "-" + day + '-能耗排名');
        this.$refs.downloadTable.export2Excel(tHeader,this.dataList,year+"-"+month+"-"+day+'-历史列表','#region-cost')


        // var info={}
        // info[this.nowDevice.name]=this.nowVariableNames
        // this.$api.reportApi.exportVariableHistoryWithDateType(JSON.stringify(info),this.datetimeValue[0],this.datetimeValue[1],this.timeInterval,this.nowDevice.name+'历史值','day',respon => {
        //   saveAs(DWSystemSetting.downloadUrl+'/'+respon,this.nowDevice.name+"历史值.xls")
        // })
      },
      selectInterval (interval) {
        this.timeInterval=interval
      },
      // 转换时间戳
      date_format_fn (value) {
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';
        let strDate=Y+M+D;
        return `'${strDate}'`
      },
    }
  }
</script>

<style scoped lang="scss">
  .myhistoryValue {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      // 正常
      .patrol {
        p {
          width: 8px;
          height: 8px;
          background-color: #0DAE88;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #0DAE88;
        }
      }

      // 非正常
      .rush {
        p {
          width: 8px;
          height: 8px;
          background-color: #FF1D1D;
          border-radius: 50%;
          margin-right: 8px;
        }

        span {
          color: #FF1D1D;
        }
      }

      .paging {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
      }

      .tree-left {
        width: 300px;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: calc(100% - 308px);
        height: 100%;
        padding: 12px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;

        .mycharts {
          display: flex;

          .charts-left {
            width: 35%;
          }

          .charts-right {
            width: 70%;
          }
        }
      }
    }
  }
</style>